export { default as CreditCardSolidIcon } from './CreditCardSolidIcon';
